export class ParentGroup {
    ParentGroupId?: number;
    ParentGroupName: string;
}
